var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoueRepare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#454d56;}.cls-4{fill:#2e353e;}.cls-5{fill:#b5c5c4;}.cls-6{fill:#c8d9d6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1772.87,1884.05l-134.17,18.3s-68.78,59.21-77.25,126c-18.3,144.34-4.07,219.55,48.79,325.26s142.3,113.84,183,107.75,99.61-18.3,134.17-44.73c16.59-12.68,63-61,63-115.87-43.39-4.46-43.39-4.46-52.88-7.17-5.83-1.66-15.91-9.68-17.62-13.55a30.72,30.72,0,0,1-1.36-9.49c0-6.43-29.82-145.06-46.09-196.58-4.85-15.37-13.55-42-25.76-69.13C1829.06,1977.75,1809.44,1937.33,1772.87,1884.05Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 roue r\xE9par\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1772.87,1884.05l-134.17,18.3s-68.78,59.21-77.25,126c-18.3,144.34,18.29,233.78,48.79,325.26,59,107.75,142.3,113.84,183,107.75s99.61-18.3,134.17-44.73c16.59-12.68,63-61,63-115.87-42.7-6.1-54.89-8.13-61-12.2s-8.13-8.13-10.17-14.23-30.49-168.73-44.72-203.29S1837.92,1965.36,1772.87,1884.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1557.38,1947.07s36.93-40,81.32-44.72c38.62-4.07,139,75.71,164.66,319.16,28.46,270.37-111.81,229.71-111.81,229.71l-211.42-176.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1660.04,
    cy: 2186.95,
    rx: 76.23,
    ry: 182.96,
    transform: "translate(-314.08 278.72) rotate(-8.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1681,2115.86s.06-30.77-36.1-21.29-37.07,77-27.59,113.2,30.5,78,51.46,74.64c50.23-8,33.26-48.84,33.26-48.84s-1.63,12.09-18.56,16-26.3-17.92-31.91-37.13-14.27-61.42,1.08-84S1681,2115.86,1681,2115.86Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoueRepare);
export default __webpack_public_path__ + "static/media/roue_repare.9b6ef156f27cc36d3bed04096c4bdf2e.svg";
export { ForwardRef as ReactComponent };